import React from "react";
import CardEducation from "../../Card Education/CardEducation";
import hof from "../../images/Hof_University_of_Applied_Sciences_Logo.jpg"
import kpb from "../../images/images.png"
import { motion } from "framer-motion";


const education=[
  {
    degree:"Master's degree, Software Engineering for Industrial Applications",
    university:"Hochschule Hof, University of Applied Sciences",
    duration:"March 2021 - March 2022",
    imageicon: hof
  },
  {
    degree:"Master's degree, Computer Science",
    university:"Karmaveer Bhaurao Patil College - India",
    duration:"Month 2016 - Month 2018",
    imageicon:kpb

  },
  {
    degree:"Bachelor's degree, Computer Science",
    university:"Karmaveer Bhaurao Patil College - India",
    duration:"Month 2013 - Month 2016",
    imageicon:kpb

  }
]


const PageTransion = {
  in:{
    opacity:1,
    y:0
  },
  out:{
    opacity:0,
    y:"-100vh"
  }
}


const Education = () => {
  return (
    <motion.div animate="in" initial="out" exit="out" variants={PageTransion} className="  flex px-8 lg:px-16 py-8 overflow-y-hidden  lg:min-h-[69vh]">
      <div className=" grid lg:grid-cols-2 gap-4 mx-auto   ">
        {/* <CardEducation />
        <CardEducation />
        <CardEducation /> */}
        {
          education.map((item,index)=>(
            <>
            <CardEducation
              key={index}
              degree={item.degree}
              university={item.university}
              duration={item.duration}
              imageicon={item.imageicon}
            />
            </>
          ))
        }
      </div>
    </motion.div>
  );
};

export default Education;
// export default Education;

